import type { ListingCardProps } from '../components/ListingCard'

/**
 * Demo electronics results. They use the existing spec-led result card: the
 * price and store sit on the photo, the three specs that decide a laptop
 * (graphics, processor, memory) sit on one strip, and the display is the
 * detail line.
 */
const IMG = {
  a: 'https://cdn.magicpatterns.com/patterns/generated-images/4e36daaa-f1bf-498d-82f2-899536b96265.jpg',
  b: 'https://cdn.magicpatterns.com/patterns/generated-images/c4c04350-de19-47ae-a3d1-e640d974fb9d.jpg',
  c: 'https://cdn.magicpatterns.com/patterns/generated-images/1ee5e246-ba6b-486d-a1bc-cf6cbf220c76.jpg',
  d: 'https://cdn.magicpatterns.com/patterns/generated-images/0a938475-4cac-43e2-8be6-64005fcbd1a9.jpg',
  e: 'https://cdn.magicpatterns.com/patterns/generated-images/5e9b4f0b-7c53-4814-9024-7c0a235c2925.jpg',
}

const laptop = (
  id: string,
  title: string,
  price: string,
  location: string,
  images: string[],
  gpu: string,
  cpu: string,
  ram: string,
  display: string,
  matchScore: number,
): ListingCardProps => ({
  id,
  title,
  price,
  location,
  images,
  specs: [
    { label: 'Graphics', value: gpu },
    { label: 'Processor', value: cpu },
    { label: 'Memory', value: ram },
    { label: 'Display', value: display },
  ],
  matchScore,
  sellerType: 'Verified Business',
  sector: 'electronics',
})

export const electronicsListings: ListingCardProps[] = [
  laptop('e1', 'Stealth 15 Gaming Laptop', 'AED 4,799', 'Dubai Mall', [IMG.a, IMG.c], 'RTX 4060', 'Core i7', '16 GB', '15.6" 240Hz QHD', 96),
  laptop('e2', 'Aero 16 Creator & Gaming', 'AED 4,950', 'Mall of the Emirates', [IMG.b, IMG.d], 'RTX 4060', 'Ryzen 7', '32 GB', '16" 165Hz OLED', 93),
  laptop('e3', 'Raptor 17 Performance', 'AED 4,599', 'Deira City Centre', [IMG.c, IMG.a], 'RTX 4070', 'Core i7', '16 GB', '17.3" 144Hz FHD', 91),
  laptop('e4', 'Nova 16 Gaming Laptop', 'AED 3,899', 'Dubai Marina', [IMG.d, IMG.b], 'RTX 4050', 'Ryzen 7', '16 GB', '16" 165Hz QHD', 88),
  laptop('e5', 'Pulse 14 Compact Gaming', 'AED 4,299', 'Business Bay', [IMG.e, IMG.a], 'RTX 4060', 'Core Ultra 7', '16 GB', '14" 120Hz OLED', 86),
  laptop('e6', 'Stealth 15 Gaming · 1 TB', 'AED 4,999', 'Dubai Mall', [IMG.a, IMG.e], 'RTX 4060', 'Core i7', '32 GB', '15.6" 240Hz QHD', 84),
]

export const electronicsNarrowed: ListingCardProps[] = [
  electronicsListings[0],
  electronicsListings[1],
  electronicsListings[4],
]
